<template>
  <!--   Main Content Start Here   -->
  <main>
    <section class="dashboard_wraper">
      <div v-if="loader">
        <div class="spinner"></div>
      </div>

      <div class="container_large">
        <div class="row">
          <!-- starting side bar -->
          <sidebar-component></sidebar-component>
          <!-- ending sidebar  -->
          <div class="col-md-12 col-lg-9">
            <div class="dashboard_card">
              <h2>Order Detail</h2>
              <div class="order_detail" v-if="order && order != null">
                <ul>
                  <li>
                    <span>Order ID</span>
                    <span>{{ order.id }}</span>
                  </li>
                  <li>
                    <span>Date</span>
                    <span>{{ order.formated_created }}</span>
                  </li>
                  <li>
                    <span>Name</span>
                    <span>{{
                      order_by && order_by.full_name ? order_by.full_name : ""
                    }}</span>
                  </li>
                  <li>
                    <span>Phone</span>
                    <span>{{
                      order_by && order_by.phone ? order_by.phone : ""
                    }}</span>
                  </li>
                  <li>
                    <span>Amount</span>
                    <span>${{ order.total }}</span>
                  </li>
                  <li>
                    <span>Status</span>
                    <!-- <span class="completed_order">Completed</span> -->
                    <span class="requested_order" v-if="order.status == '0'"
                      >Cleaning</span
                    >
                    <span class="processed_order" v-if="order.status == '1'"
                      >Cleaned and Ready to Deliver</span
                    >
                    <span class="completed_order" v-if="order.status == '2'"
                      >Completed</span
                    >
                    <span class="processed_order" v-if="order.status == '4'"
                      >Awaiting Pickup</span
                    >
                  </li>
                  <li>
                    <span>Pickup Date & Time</span>
                    <span
                      >{{new Date(order.pickupDate * 1000) | formatDate}} - {{ order.pickupTime }}</span
                    >
                  </li>
                  <li>
                    <span>Delivery Date & Time</span>
                    <span
                      >{{new Date(order.deliveryDate * 1000) | formatDate}} - {{ order.deliveryTime }}</span
                    >
                  </li>
                  <li>
                    <span>Pickup Address</span>
                    <!-- own_order is order from local DB and order is order obj from cleancloud -->
                    <span>{{
                      own_order && own_order.pickup_location
                        ? own_order.pickup_location
                        : ""
                    }}</span>
                  </li>
                  <li>
                    <span>Apartment number</span>
                    <span>{{
                      own_order && own_order.pickup_addr_apt
                        ? own_order.pickup_addr_apt
                        : ""
                    }}</span>

                  </li>
                  <li>
                    <span>Delivery Address</span>
                    <span>{{
                      own_order && own_order.delivery_location
                        ? own_order.delivery_location
                        : ""
                    }}</span>
                  </li>
                   <li>
                    <span>Apartment number</span>
                    <span>{{
                      own_order && own_order.delivery_addr_apt
                        ? own_order.delivery_addr_apt
                        : ""
                    }}</span>

                  </li>
                </ul>
              </div>
              <!-- <div class="order_items">
               
                <div
                  class="cart_row"
                  v-if="wash_products && wash_products.length"
                >
                  <h2>Wash & Fold</h2>
                  <div
                    class="cart_item"
                    v-for="data in wash_products"
                    :key="data.id"
                  >
                    <ul>
                      <li>
                        <h3>{{ data.name }}
                          <span v-if="data.id==10001">(per lb)</span>
                        </h3>
                      </li>
                      <li>
                       <select
                          class="form-select"
                          v-model="product[data.id]"
                          @change="changeWash(data.id)" v-if="data.id ==10001"
                        >
                          <option 
                           v-for="index in 300"
          :key="index"
                          :value="index">{{ index }} lbs</option>
                        
                        </select>
                         <div v-if="data.id !=10001">
                              <button
                              type="button"
                              class="count_btn decrement"
                              @click.prevent="
                                changeQty(data.id, 'wash', 'descrease')
                              "
                            >
                              <i class="fi fi-rr-minus-small"></i>
                            </button>
                            <input
                              type="text"
                              class="item_count"
                              v-model="product[data.id]"
                            />
                            <button
                              type="button"
                              class="count_btn increment"
                              @click.prevent="
                                changeQty(data.id, 'wash', 'increase')
                              "
                            >
                              <i class="fi fi-rr-plus-small"></i>
                            </button>
                            </div>
                      </li>
                      <li>
                        <strong>${{ data.total_price }}</strong>
                      </li>
                      <li>
                        <button
                          type="button"
                          @click="deleteModal('wash', data.id)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="27"
                            height="31.5"
                            viewBox="0 0 27 31.5"
                          >
                            <g id="delete" transform="translate(-4.5 -2.25)">
                              <path
                                id="Path_64"
                                data-name="Path 64"
                                d="M13.5,13.5h2.25V27H13.5Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_65"
                                data-name="Path 65"
                                d="M20.25,13.5H22.5V27H20.25Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_66"
                                data-name="Path 66"
                                d="M4.5,6.75V9H6.75V31.5A2.25,2.25,0,0,0,9,33.75H27a2.25,2.25,0,0,0,2.25-2.25V9H31.5V6.75ZM9,31.5V9H27V31.5Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_67"
                                data-name="Path 67"
                                d="M13.5,2.25h9V4.5h-9Z"
                                fill="#9cabc4"
                              />
                            </g>
                          </svg>
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div class="add_product">
                    <a href="#" @click.prevent="addProductModal('wash')"
                      ><i class="fi fi-rr-plus-small"></i> Add Product</a
                    >
                  </div>
                </div>
                <div
                  class="cart_row"
                  v-if="!wash_products || !wash_products.length"
                >
                  <h2>Wash & Fold</h2>
                  <div class="cart_item">
                    <ul>
                      No products ordered in this category
                    </ul>
                  </div>
                  <div class="add_product">
                    <a href="#" @click.prevent="addProductModal('wash')"
                      ><i class="fi fi-rr-plus-small"></i> Add Product</a
                    >
                  </div>
                </div>
               
                <div
                  class="cart_row"
                  v-if="dry_clean_products && dry_clean_products.length"
                >
                  <h2>Dry Cleaning</h2>
                  <div
                    class="cart_item"
                    v-for="data in dry_clean_products"
                    :key="data.id"
                  >
                    <ul>
                      <li>
                        <h3>{{ data.name }}</h3>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="count_btn decrement"
                          @click.prevent="
                            changeQty(data.id, 'dry_clean', 'descrease')
                          "
                        >
                          <i class="fi fi-rr-minus-small"></i>
                        </button>
                        <input
                          type="text"
                          class="item_count"
                          v-model="product[data.id]"
                        />
                        <button
                          type="button"
                          class="count_btn increment"
                          @click.prevent="
                            changeQty(data.id, 'dry_clean', 'increase')
                          "
                        >
                          <i class="fi fi-rr-plus-small"></i>
                        </button>
                      </li>
                      <li>
                        <strong>${{ data.total_price }}</strong>
                      </li>
                      <li>
                        <button
                          type="button"
                          @click="deleteModal('dry_clean', data.id)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="27"
                            height="31.5"
                            viewBox="0 0 27 31.5"
                          >
                            <g id="delete" transform="translate(-4.5 -2.25)">
                              <path
                                id="Path_64"
                                data-name="Path 64"
                                d="M13.5,13.5h2.25V27H13.5Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_65"
                                data-name="Path 65"
                                d="M20.25,13.5H22.5V27H20.25Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_66"
                                data-name="Path 66"
                                d="M4.5,6.75V9H6.75V31.5A2.25,2.25,0,0,0,9,33.75H27a2.25,2.25,0,0,0,2.25-2.25V9H31.5V6.75ZM9,31.5V9H27V31.5Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_67"
                                data-name="Path 67"
                                d="M13.5,2.25h9V4.5h-9Z"
                                fill="#9cabc4"
                              />
                            </g>
                          </svg>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div class="add_product">
                    <a href="#" @click.prevent="addProductModal('dry_clean')"
                      ><i class="fi fi-rr-plus-small"></i> Add Product</a
                    >
                  </div>
                </div>
                <div
                  class="cart_row"
                  v-if="!dry_clean_products || !dry_clean_products.length"
                >
                  <h2>Dry Cleaning</h2>
                  <div class="cart_item">
                    <ul>
                      No products ordered in this category
                    </ul>
                  </div>
                  <div class="add_product">
                    <a href="#" @click.prevent="addProductModal('dry_clean')"
                      ><i class="fi fi-rr-plus-small"></i> Add Product</a
                    >
                  </div>
                </div>
                
                <div
                  class="cart_row"
                  v-if="tailoring_products && tailoring_products.length"
                >
                  <h2>Tailoring</h2>
                  <div
                    class="cart_item"
                    v-for="data in tailoring_products"
                    :key="data.id"
                  >
                    <ul>
                      <li>
                        <h3>{{ data.name }}</h3>
                      </li>
                      <li>
                        <button type="button" class="count_btn decrement" @click.prevent="
                            changeQty(data.id, 'tailoring', 'descrease')
                          ">
                          <i class="fi fi-rr-minus-small"></i>
                        </button>
                        <input
                          type="text"
                          class="item_count"
                          v-model="product[data.id]"
                        />
                        <button type="button" class="count_btn increment" @click.prevent="
                            changeQty(data.id, 'tailoring', 'increase')
                          ">
                          <i class="fi fi-rr-plus-small"></i>
                        </button>
                      </li>
                      <li>
                        <strong>${{ data.total_price }}</strong>
                      </li>
                      <li>
                        <button v-if="order.status != '2'"
                          type="button"
                          @click="deleteModal('tailoring', data.id)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="27"
                            height="31.5"
                            viewBox="0 0 27 31.5"
                          >
                            <g id="delete" transform="translate(-4.5 -2.25)">
                              <path
                                id="Path_64"
                                data-name="Path 64"
                                d="M13.5,13.5h2.25V27H13.5Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_65"
                                data-name="Path 65"
                                d="M20.25,13.5H22.5V27H20.25Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_66"
                                data-name="Path 66"
                                d="M4.5,6.75V9H6.75V31.5A2.25,2.25,0,0,0,9,33.75H27a2.25,2.25,0,0,0,2.25-2.25V9H31.5V6.75ZM9,31.5V9H27V31.5Z"
                                fill="#9cabc4"
                              />
                              <path
                                id="Path_67"
                                data-name="Path 67"
                                d="M13.5,2.25h9V4.5h-9Z"
                                fill="#9cabc4"
                              />
                            </g>
                          </svg>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div class="add_product" v-if=" order.status != '2'">
                    <a href="#" @click.prevent="addProductModal('tailoring')"
                      ><i class="fi fi-rr-plus-small"></i> Add Product</a
                    >
                  </div>
                </div>
                <div
                  class="cart_row"
                  v-if="!tailoring_products || !tailoring_products.length"
                >
                  <h2>Tailoring</h2>
                  <div class="cart_item">
                    <ul>
                      No products ordered in this category
                    </ul>
                  </div>
                  <div class="add_product">
                    <a href="#" @click.prevent="addProductModal('tailoring')"
                      ><i class="fi fi-rr-plus-small"></i> Add Product</a
                    >
                  </div>
                </div>
              </div> -->
              <br />
              <div
                class="alert alert-success alert-dismissible"
                v-if="status && status == 200"
              >
                <strong>Success!</strong> Action performed successfully.
              </div>
              <div
                class="alert alert-danger alert-dismissible"
                v-if="status && status == 400 && errors"
              >
                <strong>Failed!</strong> {{errors}}.
              </div>
              <div v-if="params_type && params_type=='edit' && is_paid" class="text-danger">This order is already processed and can't be updated</div>
              <div class="order_buttons" v-if="params_type && params_type=='edit' && !is_paid">
                <!-- <a  class="button secondary_button pointer" @click.prevent="updateOrder('save')">Save</a> -->
                <!-- <a
                  class="button primary_button pointer"
                  @click.prevent="openChargeModal()"
                  >Save & Charge</a
                > -->
                 <a
                  class="button primary_button pointer"
                  @click.prevent="openChargeModal()"
                  >Charge</a
                >
              </div>

              <div class="order_buttons" v-if="params_type && params_type=='edit' && is_paid">
                <router-link  class="button secondary_button pointer btn_gray" :to="{name:'admin-orders'}">Back</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- charge confirmation modal -->

       <div
        class="modal fade"
        id="chargeModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="close_modal">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fi fi-rr-cross-small"></i>
                </button>
              </div>
              <div class="modal_content">
                <h2>Confirmation</h2>
                <p>Once its charged you will not be able to modify order details.</p>

                <div class="modal_buttons">
                  <button
                    type="button"
                    class="button secondary_button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="button primary_button"
                     @click.prevent="updateOrder('charge')"
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- delete cofirmation modal -->

      <div
        class="modal fade"
        id="deleteModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="close_modal">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fi fi-rr-cross-small"></i>
                </button>
              </div>
              <div class="modal_content">
                <h2>Confirmation</h2>
                <p>Are you sure want to delete this item?</p>

                <div class="modal_buttons">
                  <button
                    type="button"
                    class="button secondary_button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    class="button primary_button"
                    @click.prevent="deleteItem()"
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- end delete confirmation modal -->

      <!-- add product wash modal-->

      <div
        class="modal fade"
        id="washModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-body">
              <div class="close_modal">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fi fi-rr-cross-small"></i>
                </button>
              </div>
              <div class="modal_content">
                <h2>Wash & Fold</h2>
                <div class="my_items my_tailored">
                  <div class="row">
                    <div
                      class="col-6 col-md-4 col-lg-3"
                      v-for="data in wash_clean_products"
                      :key="data"
                    >
                      <div
                        class="item_col"
                        @click.prevent="
                          cartProducts(data, 1, 'wash', 'wash_product');
                          activate(data.id, 'wash');
                        "
                        :class="{ active: isActive(data.id) }"
                      >
                        <div class="item_img">
                          <img
                            :src="data.ic?
                              'https://s3.us-east-2.amazonaws.com/cleancloudapp/ic/b/' +
                              data.ic :'/src/assets/images/image-placeholder.png'
                            "
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <div class="item_col_content">
                          <span>
                            $
                            {{
                              product[data.id]
                                ? product[data.id] * data.price
                                : data.price
                            }}</span
                          >
                          <ul>
                            
                            <li>
                              <input
                                type="text"
                                class="item_count"
                                v-model="product[data.id]"
                              />
                              {{ data.name ? data.name : "" }}
                            </li>
                            
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal_buttons">
                  <button
                    type="button"
                    class="button secondary_button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- end wash add modal -->

      <!-- add product dry clean modal-->

      <div
        class="modal fade"
        id="dryCleanModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-body">
              <div class="close_modal">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fi fi-rr-cross-small"></i>
                </button>
              </div>
              <div class="modal_content">
                <h2>Dry Cleaning</h2>
                <div class="my_items my_tailored">
                  <div class="row">
                    <div
                      class="col-6 col-md-4 col-lg-3"
                      v-for="data in dry_clean_clean_products"
                      :key="data"
                    >
                      <div
                        class="item_col"
                        @click.prevent="
                          cartProducts(
                            data,
                            1,
                            'dry_clean',
                            'dry_clean_product'
                          );
                          activate(data.id,'dry_clean');
                        "
                        :class="{ active: isActive(data.id) }"
                      >
                        <div class="item_img">
                          <img
                            :src="data.ic?
                              'https://s3.us-east-2.amazonaws.com/cleancloudapp/ic/b/' +
                              data.ic :'/src/assets/images/image-placeholder.png'
                            "
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <div class="item_col_content">
                          <span>
                            $
                            {{
                              product[data.id]
                                ? product[data.id] * data.price
                                : data.price
                            }}</span
                          >
                          <ul>
                            
                            <li>
                              <input
                                type="text"
                                class="item_count"
                                v-model="product[data.id]"
                              />
                              {{ data.name ? data.name : "" }}
                            </li>
                            
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal_buttons">
                  <button
                    type="button"
                    class="button secondary_button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Close
                  </button>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- end dry clean add modal -->

      <!-- add product tailoring modal-->
      <div
        class="modal fade"
        id="tailoringModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-body">
              <div class="close_modal">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fi fi-rr-cross-small"></i>
                </button>
              </div>
              <div class="modal_content">
                <h2>Tailoring Products</h2>

                <div class="my_items my_tailored">
                  <div class="row">
                    <div
                      class="col-6 col-md-4 col-lg-3"
                      v-for="data in tailoring_clean_products"
                      :key="data"
                    >
                      <div
                        class="item_col"
                        @click.prevent="
                          cartProducts(
                            data,
                            1,
                            'tailoring',
                            'tailoring_product'
                          );
                          activate(data.id,'tailoring');
                        "
                        :class="{ active: isActive(data.id) }"
                      >
                        <div class="item_img">
                          <img
                            :src="data.ic?
                              'https://s3.us-east-2.amazonaws.com/cleancloudapp/ic/b/' +
                              data.ic :'/src/assets/images/image-placeholder.png'
                            "
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <div class="item_col_content">
                          <span>
                            $
                            {{
                              product[data.id]
                                ? product[data.id] * data.price
                                : data.price
                            }}</span
                          >
                          <ul>
                           
                            <li>
                              <input
                                type="text"
                                class="item_count"
                                v-model="product[data.id]"
                              />
                              {{ data.name ? data.name : "" }}
                            </li>
                            
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal_buttons">
                  <button
                    type="button"
                    class="button secondary_button"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- end tailoring add modal -->
    </section>
  </main>

  <!--   Main Content End Here   -->
</template>
<script>
import usersApis from "../../Apis/users";
import ordersApis from "../../Apis/orders";
import sidebarComponent from "./sidebar";
import moment from "moment";
import productsApis from "../../Apis/products";
export default {
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,
      params_type: null,
      is_paid: false,
      order: null,
      order_by: null,
      own_order: null,
      status: null,
      delete_obj: {},

      product: {},

      wash_products: [],
      wash_product_weight: {},
      dry_clean_products: [],
      tailoring_products: [],

      sum_wash: 0,
      sum_dry_clean: 0,
      sum_tailoring: 0,
      sub_total: 0,
      grand_total: 0,

      updateObj: {
        id: null,
        wash_products: null,
        dry_clean_products: null,
        tailoring_products: null,
        customerID: null,
        total: null,
      },

      // clean_products: null,
      wash_clean_products: [],
      dry_clean_clean_products: [],
      tailoring_clean_products: [],
      errors: null,
    };
  },
  watch: {
    sum_wash: function (val) {
      let wash_price = this.sum_wash;
      this.sub_total = this.sum_dry_clean + wash_price + this.sum_tailoring;
    },
    sum_dry_clean: function (val) {
      let wash_price = this.sum_wash;
      this.sub_total = this.sum_dry_clean + wash_price + this.sum_tailoring;
    },
    sum_tailoring: function (val) {
      let wash_price = this.sum_wash;
      this.sub_total = this.sum_dry_clean + wash_price + this.sum_tailoring;
    },
    sub_total: function (val) {
      const total = parseFloat(this.sub_total);
      this.grand_total = total.toFixed(2);
    },
    // dry_clean_products:{
    //   handler: function (val, oldVal) {
    //     this.calculateSum();
    //   },
    //   deep: true
    // },
  },
  methods: {
    deleteModal(type, id) {
      this.delete_obj = { type: type, id: id };

      var myModal = new bootstrap.Modal(document.getElementById("deleteModal"));
      myModal.show();
    },

    async deleteItem() {
      this.loader = true;

      if (this.delete_obj.type == "wash") {
        const index = this.wash_products.findIndex(
          (it) => it.id === this.delete_obj.id
        );
        if (index != -1) {
          this.wash_products.splice(index, 1);
        }
      } else if (this.delete_obj.type == "dry_clean") {
        const index = this.dry_clean_products.findIndex(
          (it) => it.id === this.delete_obj.id
        );
        if (index != -1) {
          this.dry_clean_products.splice(index, 1);
        }
      } else if (this.delete_obj.type == "tailoring") {
        const index = this.tailoring_products.findIndex(
          (it) => it.id === this.delete_obj.id
        );
        if (index != -1) {
          this.tailoring_products.splice(index, 1);
        }
      }


      if(this.product[this.delete_obj.id]){
        delete this.product[this.delete_obj.id];
      }
      
      this.delete_obj = {};

      this.calculateSum();

      var myModal = new bootstrap.Modal(document.getElementById("deleteModal"));
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");
      this.loader = false;
    },
    openChargeModal(){
      var myModal = new bootstrap.Modal(document.getElementById("chargeModal"));
      myModal.show();
    },
    async addProductModal(type) {
      if (type == "wash") {
        var myModal = new bootstrap.Modal(document.getElementById("washModal"));
        myModal.show();
      } else if (type == "dry_clean") {
        var myModal = new bootstrap.Modal(
          document.getElementById("dryCleanModal")
        );
        myModal.show();
      } else if (type == "tailoring") {
        var myModal = new bootstrap.Modal(
          document.getElementById("tailoringModal")
        );
        myModal.show();
      }
    },
    /** CTA for get clean cloud products from backend*/
    async getProducts() {
      const data = (await productsApis.getCleanCloudProducts()).data;
      if (data && data.Products) {
        // this.clean_products = data.Products;
        data["Products"].forEach((element) => {
          if (
            element.section &&
            element.section == process.env.WASH_CLEAN_KEY
          ) {
            this.wash_clean_products.push(element);
          }
          if (element.section && element.section == process.env.DRY_CLEAN_KEY) {
            this.dry_clean_clean_products.push(element);
          }
          if (
            element.section &&
            element.section == process.env.TAILORING_CLEAN_KEY
          ) {
            this.tailoring_clean_products.push(element);
          }
        });
      }
    },
    isActive(id) {
      if (this.product[id]) {
        return true;
      }
    },
    activate(id, type) {
      // setting quantity of product with its id
      if (!this.product[id]) {

        /** because min. weight for wash and fold is 15 lb */
        if(type =='wash' && id==10001){
        this.product[id] = 15;
        } else{
            this.product[id] = 1;
        }
        
      }
    },
    /** CTA for adding new product */
    cartProducts(product, qty, type, call_from) {
      product.type = type;
      product.quantity = this.product[product.id]
        ? this.product[product.id]
        : qty;
      product.total_price = product.price * product.quantity;

      if (call_from == "wash_product") {
        const index = this.wash_products.findIndex(
          (it) => it.id === product.id
        );
        if (index === -1) {
          this.wash_products.push(product);
        }
      }
      if (call_from == "dry_clean_product") {
        const index = this.dry_clean_products.findIndex(
          (it) => it.id === product.id
        );
        if (index === -1) {
          this.dry_clean_products.push(product);
        }
      }

      if (call_from == "tailoring_product") {
        const index = this.tailoring_products.findIndex(
          (it) => it.id === product.id
        );
        if (index === -1) {
          this.tailoring_products.push(product);
        }
      }
     this.calculateSum();
    },
    changeWash(id) {
      if (this.product[id] >= 15) {
        const index = this.wash_products.findIndex((it) => it.id == id);
        const objectVal = this.wash_products.find((it) => it.id == id);
        objectVal.quantity = parseInt(this.product[id]);
        objectVal.total_price = objectVal.quantity * objectVal.price;
      } else {
        const index = this.wash_products.findIndex((it) => it.id == id);
        const objectVal = this.wash_products.find((it) => it.id == id);
        objectVal.quantity = 15;
        objectVal.total_price = objectVal.quantity * objectVal.price;
      }
      this.calculateSum();
    },
    /** CTA for changing qty of product */
    changeQty(id, type, action_type) {
      if(type == "wash"){
         const index = this.wash_products.findIndex((it) => it.id == id);
         const objectVal = this.wash_products.find((it) => it.id == id);
        var currentVal = this.product[id];
        if (action_type == "descrease" && currentVal > 1) {
          currentVal--;
          this.product[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        } else if (action_type == "increase") {
          currentVal++;
          this.product[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        }

        this.wash_products[index] = objectVal;
      }
      if (type == "tailoring") {
        const index = this.tailoring_products.findIndex((it) => it.id == id);
        const objectVal = this.tailoring_products.find((it) => it.id == id);
        var currentVal = this.product[id];
        if (action_type == "descrease" && currentVal > 1) {
          currentVal--;
          this.product[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        } else if (action_type == "increase") {
          currentVal++;
          this.product[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        }

        this.tailoring_products[index] = objectVal;
        // this.$store.dispatch("setCart", objectVal);
      } else if (type == "dry_clean") {
        const index = this.dry_clean_products.findIndex((it) => it.id == id);
        const objectVal = this.dry_clean_products.find((it) => it.id == id);
        var currentVal = this.product[id];
        if (action_type == "descrease" && currentVal > 1) {
          currentVal--;
          this.product[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        } else if (action_type == "increase") {
          currentVal++;
          this.product[id] = currentVal;
          objectVal.quantity = currentVal;
          objectVal.total_price = currentVal * objectVal.price;
        }
        // this.$store.dispatch("setCart", objectVal);
        this.dry_clean_products[index] = objectVal;
      }

      this.$forceUpdate();
      this.calculateSum();
    },
    calculateSum() {
      this.sum_wash = 0;
      this.sum_dry_clean = 0;
      this.sum_tailoring = 0;
      // this.grand_total = 0;

      let wash_price = this.sum_wash;
      // if(this.orderObj.is_wash_premium){
      //   wash_price = parseFloat(this.orderObj.wash_premium_fee) + wash_price;
      // }

      if (this.wash_products && this.wash_products.length) {
        this.wash_products.forEach((element) => {
          this.sum_wash += parseFloat(element.total_price.toFixed(2));
        });
      }
      if (this.dry_clean_products && this.dry_clean_products.length) {
        this.dry_clean_products.forEach((element) => {
          this.sum_dry_clean += parseFloat(element.total_price.toFixed(2));
        });
      }
      if (this.tailoring_products && this.tailoring_products.length) {
        this.tailoring_products.forEach((element) => {
          this.sum_tailoring += parseFloat(element.total_price.toFixed(2));
        });
      }

      // const total = parseFloat(this.sub_total) + parseFloat(this.service_fee);
      // this.grand_total = total.toFixed(2);
    },
    setProducts() {
      if (this.own_order && this.own_order.order_products) {
        const products = this.own_order.order_products;
        products.forEach((element) => {
          if (
            element.section &&
            element.section == process.env.WASH_CLEAN_KEY
          ) {
            this.product[element.id] = element.quantity;
            // this.wash_product_weight[element.id]
            this.wash_products.push(element);
          }
          if (
            element.section &&
            element.section == process.env.TAILORING_CLEAN_KEY
          ) {
            this.product[element.id] = element.quantity;
            this.tailoring_products.push(element);
          }
          if (element.section && element.section == process.env.DRY_CLEAN_KEY) {
            this.product[element.id] = element.quantity;
            this.dry_clean_products.push(element);
          }
        });
        this.calculateSum();
      }
    },
    async updateOrder(type) {
      this.loader = true;
      if (this.wash_products) {
        this.updateObj.wash_products = this.wash_products;
      }
      if (this.dry_clean_products) {
        this.updateObj.dry_clean_products = this.dry_clean_products;
      }
      if (this.tailoring_products) {
        this.updateObj.tailoring_products = this.tailoring_products;
      }
      // this.updateObj.total = this.grand_total;
      this.updateObj.total = this.order.total; // july 2021 onward => Only depend on Clean Cloud Total as it can be changed directly from there.
      this.updateObj.type= type;
      const response = await ordersApis.requestOrders("put", this.updateObj).then((response) => {
            console.log(response);
            if (response.status == 200 || response.status == 204) {
             this.status = 200;

             if(type=='charge'){
                var myModal = new bootstrap.Modal(document.getElementById("deleteModal"));
                myModal.hide();

                $("body").removeClass("modal-open");
                $(".fade").removeClass("show");
                $("body").css("padding-right", "0px");             }
                this.loader = false;
                setTimeout(() => {
                  this.$router.push({ name: "admin-orders" });
                }, 1000);
               
            }
          })
          .catch((error) => {
            this.loader = false;
            console.log(error.response)
            
            
            this.status =
              error.response && error.response.status
                ? error.response.status
                : "";
                if(error.response && error.response.data && error.response.data.Errors){
                    this.errors = error.response.data.Errors
                }
                


            // if(error.response && error.response.data && error.response.data.message){
            //   this.stripe_error = error.response.data.message
            // }
          })
          .then(() => {
            this.loader = false;
          }); ;;
      // if (
      //   response &&
      //   response.status &&
      //   (response.status == 200 || response.status == 204)
      // ) {
      //   this.loader = false;
      //   this.status = 200;

      //   setTimeout(() => {
      //     this.$router.push({ name: "admin-orders" });
      //   }, 2000);
      // }
    },
  },
  async created() {
    this.params_type = this.$route.params.type ? this.$route.params.type :'';
    await this.getProducts();
    if (this.$route.params.id) {
      this.updateObj.id = this.$route.params.id;
      this.order = (await usersApis.getOrder(this.$route.params.id)).data;
      

      if (this.order) {
        this.order_by = this.order.order_user;
        this.updateObj.customerID = this.order.customerID;
        this.order.formated_created = moment
          .unix(this.order.createdDate)
          // .format("DD-MM-YYYY");
          .format("MM-DD-YYYY");

        this.own_order = this.order.own_orders ? this.order.own_orders : "";
          if(this.order.paid =='1' ||  this.order.status=='2'){
          this.is_paid = true;
        }

        this.setProducts();
      }
    }

   this.loader = false;
  },
   filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format("dddd, MMMM Do YYYY");
      }
     },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/adminOrderDetails.vue